import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=9e48a494&"
import script from "./FirstPage.vue?vue&type=script&lang=ts&"
export * from "./FirstPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports